import mixin from "@/mixin/index.js";
import BigNumber from "bignumber.js";
const _formatNumber = mixin.methods._formatNumber;
const _roundNumber = mixin.methods._roundNumber;

const simpleFluidTherapy = {
    name: 'Taxa de Fluidoterapia | Simples',
    id: '3ec0acf03c3711ee560242ac120002',
    classes: ['Fluidoterapia'],
    premium: true,
    variables: [
        {
            name: 'Peso do paciente (kg)',
            type: 'number',
            placeholder: 'Insira o Peso do Paciente',
            id: 'weight',
            default: 0,
            suffix: 'kg'
        },
        {
            name: 'Escolha a unidade de medida da Taxa',
            type: 'select',
            clearable: true,
            placeholder: 'Selecione',
            id: 'rateUnit',
            items: ['mL/kg/hora', 'mL/kg/dia'],
            default: null,
        },
        {
            name: 'Valor da Taxa',
            type: 'number',
            placeholder: 'Insira o valor da Taxa',
            id: 'rate',
            default: null,
            suffix: null
        },
    ],
    calculate: ({ weight, rateUnit, rate }) => {
        if (!weight || !rateUnit || !rate) {
            return;
        }
        weight = new BigNumber(weight.replace(',', '.'));
        let response = { type: 'multiple', values: [] };
        const rateUnitFactor = { 'mL/kg/hora': 1, 'mL/kg/dia': 24 }[rateUnit];
        let speed = weight.times(rate).dividedBy(rateUnitFactor);
        response.values.push({ description: 'Velocidade na bomba de infusão', value: _formatNumber(_roundNumber(speed, 2), ' mL/hora'), hideResultClass: true });
        response.values.push({
            description: 'Velocidade no equipo Macrogotas', values: [
                _formatNumber(_roundNumber(speed.dividedBy(180), 2), ' gotas/segundo'),
                _formatNumber(_roundNumber(speed.dividedBy(18), 2), ' gotas/10 segundos'),
                _formatNumber(_roundNumber(speed.dividedBy(3), 2), ' gotas/minuto'),
                _formatNumber(_roundNumber(new BigNumber(180).dividedBy(speed), 2), ' segundos/gota'),
            ], hideResultClass: true
        });
        response.values.push({
            description: 'Velocidade no equipo Microgotas', values: [
                _formatNumber(_roundNumber(speed.dividedBy(60), 2), ' gotas/segundo'),
                _formatNumber(_roundNumber(speed.dividedBy(6), 2), ' gotas/10 segundos'),
                _formatNumber(_roundNumber(speed, 2), ' gotas/minuto'),
                _formatNumber(_roundNumber(new BigNumber(60).dividedBy(speed), 2), ' segundos/gota'),
            ], hideResultClass: true
        });
        return response;
    },
    responseLabel: "Velocidade de Administração",
    sections: [],
    references: []
}

export default { simpleFluidTherapy }